import { UniversalFilterInvoicesFilterOptions } from './components/UniversalFilterInvoices';

export { UniversalFilterTextModes } from './components/UniversalFilterText';

import {
  UniversalFilterInvoiceStatusFilterOptions,
  UniversalFilterTaskStatusFilterOptions
} from './components/UniversalFilterTaskStatus';
import { UniversalFilterTextFilterOptions } from './components/UniversalFilterText';
import { UniversalFilterUsersFilterOptions } from './components/UniversalFilterUsers';
import { UniversalFilterUsersExtendedFilterOptions } from './components/UniversalFilterUsersExtended';

import { I18nText } from '../../../types';
import { UniversalFilterItemTagsFilterOptions } from './components/UniversalFilterItemTags';
import { UniversalFilterInvoiceProcessingJobStatusFilterOptions } from './components/UniversalFilterInvoiceProcessingJobStatus';
import { UniversalFilterNumberFilterOptions } from './components/UniversalFilterNumber';

export const enum UniversalFilterTypes {
  BINDING_STATUS = 'binging_status',
  CHECKBOX = 'checkbox',
  COMPANIES = 'companies',
  COMPANY_NANO_ID = 'company_nano_id',
  DATE = 'date',
  INVOICE_PROCESSING_JOB_STATUS = 'invoice_processing_job_status',
  INVOICE_STATUS = 'invoice_status',
  INVOICES_ID = 'invoices_id',
  ITEM_TAGS_ID = 'item_tags_id',
  NUMBER = 'number',
  OPERATION_STATE = 'operation_state',
  OPERATION_TYPE = 'operation_type',
  PROJECT_STATUS = 'project_status',
  COMPANY_STATUS = 'company_status',
  COMPANY_NEW_FIN_STATUS = 'company_new_fin_status',
  COMPANY_NEW_FIN_TAGS = 'company_new_fin_tags',
  COMPANY_FIN_CATEGORIES = 'company_fin_categories',
  TAG_ID = 'tag_id',
  TAGS = 'tags',
  TASK_ITEMS = 'task_items',
  TASK_STATUS = 'task_status',
  TEXT = 'text',
  TEXT_PLAIN = 'text_plain',
  USERS = 'users',
  USERS_EXTENDED = 'users_extended'
}

export const enum UniversalFilterView {
  TABLE = 'table'
}

export type UniversalFilterFieldName<T> = Extract<keyof T, string>;

export type UniversalFilterBaseField<
  T extends UniversalFilterTypes,
  FiltersType extends Record<string, any>,
  Options = never
> = {
  fieldName: UniversalFilterFieldName<FiltersType>;
  type: T;
  i18nName: I18nText;
  options?: Options;
  initialAutoFocus?: boolean;
};

export type UniversalFilterField<FiltersType extends Record<string, any>> =
  | UniversalFilterBaseField<UniversalFilterTypes.CHECKBOX, FiltersType>
  | UniversalFilterBaseField<UniversalFilterTypes.COMPANIES, FiltersType>
  | UniversalFilterBaseField<UniversalFilterTypes.COMPANY_NANO_ID, FiltersType>
  | UniversalFilterBaseField<UniversalFilterTypes.DATE, FiltersType>
  | UniversalFilterBaseField<UniversalFilterTypes.OPERATION_STATE, FiltersType>
  | UniversalFilterBaseField<UniversalFilterTypes.OPERATION_TYPE, FiltersType>
  | UniversalFilterBaseField<UniversalFilterTypes.PROJECT_STATUS, FiltersType>
  | UniversalFilterBaseField<UniversalFilterTypes.COMPANY_STATUS, FiltersType>
  | UniversalFilterBaseField<
      UniversalFilterTypes.COMPANY_NEW_FIN_STATUS,
      FiltersType
    >
  | UniversalFilterBaseField<
      UniversalFilterTypes.COMPANY_NEW_FIN_TAGS,
      FiltersType
    >
  | UniversalFilterBaseField<
      UniversalFilterTypes.COMPANY_FIN_CATEGORIES,
      FiltersType
    >
  | UniversalFilterBaseField<UniversalFilterTypes.TAG_ID, FiltersType>
  | UniversalFilterBaseField<UniversalFilterTypes.TAGS, FiltersType>
  | UniversalFilterBaseField<UniversalFilterTypes.TASK_ITEMS, FiltersType>
  | UniversalFilterBaseField<
      UniversalFilterTypes.TASK_STATUS,
      FiltersType,
      UniversalFilterTaskStatusFilterOptions
    >
  | UniversalFilterBaseField<
      UniversalFilterTypes.TEXT,
      FiltersType,
      UniversalFilterTextFilterOptions
    >
  | UniversalFilterBaseField<UniversalFilterTypes.TEXT_PLAIN, FiltersType>
  | UniversalFilterBaseField<
      UniversalFilterTypes.NUMBER,
      FiltersType,
      UniversalFilterNumberFilterOptions
    >
  | UniversalFilterBaseField<
      UniversalFilterTypes.USERS,
      FiltersType,
      UniversalFilterUsersFilterOptions
    >
  | UniversalFilterBaseField<
      UniversalFilterTypes.INVOICE_STATUS,
      FiltersType,
      UniversalFilterInvoiceStatusFilterOptions
    >
  | UniversalFilterBaseField<
      UniversalFilterTypes.INVOICES_ID,
      FiltersType,
      UniversalFilterInvoicesFilterOptions
    >
  | UniversalFilterBaseField<
      UniversalFilterTypes.INVOICE_PROCESSING_JOB_STATUS,
      FiltersType,
      UniversalFilterInvoiceProcessingJobStatusFilterOptions
    >
  | UniversalFilterBaseField<
      UniversalFilterTypes.ITEM_TAGS_ID,
      FiltersType,
      UniversalFilterItemTagsFilterOptions
    >
  | UniversalFilterBaseField<UniversalFilterTypes.BINDING_STATUS, FiltersType>
  | UniversalFilterBaseField<
      UniversalFilterTypes.USERS_EXTENDED,
      FiltersType,
      UniversalFilterUsersExtendedFilterOptions
    >;
